import useStore from "Store";
import {
  AttributeDescription,
  CustomSizeItem,
  CustomSizeItemInput,
  CustomSizeItemInputContainer,
  CustomSizeItemName,
  CustomSizesComponentContainer,
  CustomSizesContainer,
} from "./LayoutStyled";
import { FC, useEffect, useState } from "react";
import { T } from "Helpers";
import { CloseEditorButton } from "components/Atomic";
import Tooltip from "components/widgets/tooltip";
import { MessageDialog, useDialogManager } from "components/dialogs/Dialogs";
import { Attribute } from "@zakeke/zakeke-configurator-react";
import { CustomSize } from "Interfaces";

const CustomSizesComponent: FC<{
  attribute: Attribute;
  onCloseClick?: () => void;
}> = ({ attribute, onCloseClick }) => {
  const {
    customSizes,
    personalDetailsData,
    setPersonalDetailsData,
    setInitializeCustomSizes,
    setCustomSizes,
    isMobile,
  } = useStore();
  const { showDialog } = useDialogManager();
  const [isPersonalDataAttribute, setisPersonalDataAttribute] =
    useState<boolean>();

  useEffect(() => {
    attribute &&
      setisPersonalDataAttribute(
        attribute.name.toLowerCase() === "personal details"
      );
    if (
      attribute &&
      !(attribute.name.toLowerCase() === "personal details") &&
      customSizes.length === 0
    ) {
      let initialCustomSizes: CustomSize[] = [];
      attribute.options.forEach((option) => {
        initialCustomSizes.push({
          label: option.name,
          value: "",
        });
      });

      setInitializeCustomSizes(initialCustomSizes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customSizes, personalDetailsData, attribute]);

  return (
    <CustomSizesComponentContainer isMobile={isMobile}>
      <CustomSizesContainer
        toBeEnlarged={
          attribute
            ? attribute.name.toLowerCase() === "send sample shirt" ||
              attribute.name.toLowerCase() ===
                "follow previous order measurements"
            : false
        }
      >
        {attribute &&
          attribute.options.map((option) => {
            return (
              <CustomSizeItem
                key={option.name}
                toBeEnlarged={
                  attribute
                    ? attribute.name.toLowerCase() === "send sample shirt" ||
                      attribute.name.toLowerCase() ===
                        "follow previous order measurements"
                    : false
                }
              >
                {option.description !== "" && (
                  <Tooltip
                    key={"tooltip" + option.name}
                    onClick={() =>
                      showDialog(
                        "message",
                        <MessageDialog
                          isInfoSizeDialog
                          message={T._(option.description, "Composer")}
                          imgUrl={option.imageUrl ?? ""}
                        />
                      )
                    }
                    optionDescription={option.description}
                    isMobile={isMobile}
                    isCustomSizeIcon
                  />
                )}
                <CustomSizeItemName>{option.name}</CustomSizeItemName>
                <CustomSizeItemInputContainer
                  toBeEnlarged={
                    attribute
                      ? attribute.name.toLowerCase() === "send sample shirt" ||
                        attribute.name.toLowerCase() ===
                          "follow previous order measurements"
                      : false
                  }
                >
                  {isPersonalDataAttribute ? (
                    <CustomSizeItemInput
                      min={"0"}
                      max={"200"}
                      type={"string"}
                      // value={customSize.value === 0 ? "" : customSize.value}
                      value={
                        personalDetailsData.find(
                          (personalData) => personalData.label === option.name
                        )?.value
                      }
                      onChange={(e) => {
                        setPersonalDetailsData(
                          option.name,
                          e.currentTarget.value
                        );
                      }}
                      placeholder={option.name}
                    />
                  ) : (
                    <CustomSizeItemInput
                      toBeEnlarged={
                        attribute
                          ? attribute.name.toLowerCase() ===
                              "send sample shirt" ||
                            attribute.name.toLowerCase() ===
                              "follow previous order measurements"
                          : false
                      }
                      min={"0"}
                      max={"200"}
                      type={"string"}
                      // value={customSize.value === 0 ? "" : customSize.value}
                      value={
                        customSizes.find(
                          (customSize) => customSize.label === option.name
                        )?.value
                      }
                      onChange={(e) => {
                        setCustomSizes(option.name, e.currentTarget.value);
                      }}
                      placeholder={option.name}
                    />
                  )}
                </CustomSizeItemInputContainer>
              </CustomSizeItem>
            );
          })}
      </CustomSizesContainer>
      {isMobile && (
        <CloseEditorButton onClick={onCloseClick}>
          {T._("OK", "Composer")}
        </CloseEditorButton>
      )}
      <AttributeDescription>
        {attribute?.description}
      </AttributeDescription>
    </CustomSizesComponentContainer>
  );
};

export default CustomSizesComponent;
